import { queryString, } from '../../../jsCore/utils/window';
import { info, } from '../../../jsCore/application/console';
import { namespacedConsts, } from '../../../jsCore/utils/object';


const { overrideNumFantasyTournaments, debugFantasyTournaments, mockFantasyTournamentsCurrency, } = queryString;
const currencyName2Symbol = {
  USD: '$',
  GBP: '£',
};
export const CURRENCY_DISPLAY_TYPES = namespacedConsts({
  SYMBOL: true, // eg: $, £
  NAME: true, // eg: USD, EUR, GBP, NIS, CNY
});


function getCurrencyData(currencyName){
  if (mockFantasyTournamentsCurrency && mockFantasyTournamentsCurrency.length) {
    info(
      `[YAHOO_FANTASY] getCurrencyData: mocking tournament currency with '${ mockFantasyTournamentsCurrency }'`,
      { currencyName, mockFantasyTournamentsCurrency, currencyName2Symbol, }
    );
    currencyName = mockFantasyTournamentsCurrency; // eslint-disable-line no-param-reassign
  }
  const symbol = currencyName2Symbol[currencyName.toUpperCase()];
  if (symbol) {
    return {
      type: CURRENCY_DISPLAY_TYPES.SYMBOL,
      value: symbol,
    };
  }
  return {
    type: CURRENCY_DISPLAY_TYPES.NAME,
    value: currencyName,
  };
}

function getLinkFromId(id){
  return `https://sports.yahoo.com/dailyfantasy/contest/${ id }/setlineup`;
}

function transformTournament({
    id,
    title,
    entryLimit: totalEntries,
    entryCount: currentEntriesCount,
    paidEntryFee,
    paidTotalPrize,
  }){
  const { amount: entryFeeAmount, currency, } = paidEntryFee;
  const currencyData = getCurrencyData(currency);
  const { amount: prizeAmount, } = paidTotalPrize;
  const link = getLinkFromId(id);
  return {
    title,
    currentEntriesCount,
    currency: currencyData,
    totalEntries,
    entryFeeAmount,
    prizeAmount,
    redirectionUrl: '',
    link,
  };
}

export function transformFantasyTournaments({ contests, }){
  const args = arguments
  if (debugFantasyTournaments) {
    info('[YAHOO_FANTASY] transformFantasyTournaments', { contests, args, });
  }
  if (!contests || !contests.result) {
    return [];
  }
  const { result: tournaments, } = contests;
  // allow faking number of tournaments for QA
  if (overrideNumFantasyTournaments && !isNaN(overrideNumFantasyTournaments)) {
    const len = parseInt(overrideNumFantasyTournaments, 10);
    return Array(len).fill(transformTournament(tournaments[0]));
  }
  return tournaments.map(transformTournament);
}



// WEBPACK FOOTER //
// ./provolution/app/views/provolution/components/fantasy/transformers/fantasyTournamentTransformer.js